<form class="mobile-search" role="search" [attr.aria-label]="'mobileShortcuts.searchLabel' | translate" (submit)="dismiss($event)" (keydown.escape)="dismiss($event)">
  <div class="mobile-search__field">
    <span class="material-symbols-outlined mobile-search__icon" aria-hidden="true">search</span>
    <div class="mobile-search__input-group">
      <label for="mobile-search-input">{{ 'mobileShortcuts.searchLabel' | translate }}</label>
      <input
        #searchInput
        id="mobile-search-input"
        type="search"
        autocomplete="off"
        enterkeyhint="search"
        [placeholder]="'mobileShortcuts.searchPlaceholder' | translate"
        [value]="sportsbook.searchQuery()"
        (input)="onInput($event)"
      />
    </div>
    @if (sportsbook.searchQuery().length > 0) {
      <button type="button" class="mobile-search__icon-button" [attr.aria-label]="'search.clear' | translate" (click)="clear()">
        <span class="material-symbols-outlined" aria-hidden="true">close</span>
      </button>
    }
  </div>
  <button type="button" class="mobile-search__icon-button" [attr.aria-label]="'search.close' | translate" (click)="dismiss()">
    <span class="material-symbols-outlined" aria-hidden="true">keyboard_arrow_down</span>
  </button>
</form>
